<app-widget-base [title]="referenceTitle">
  <button class="remove-btn" *ngIf="campaign" (click)="deleteCampaign()">
    <img src="/assets/img/icons/positive-clear/delete.svg" />
  </button>
  <div class="campaign reference" *ngIf="campaign">
    <p class="name">{{ campaign.name }}</p>
    <div class="top">
      <img src="/assets/img/icons/accent/map-xs.svg" />
      <p>{{ campaignPOIs.length }} POIs</p>
      <div class="spacer"></div>
      <button (click)="showAll()">{{ 'Show all' | translate }}</button>
    </div>
    <div class="dates">
      <div class="date-row">
        <p class="label">{{ 'Start' | translate }}</p>
        <p class="date">{{ formatDate(campaign.start) }}</p>
      </div>
      <div class="date-row">
        <p class="label">{{ 'End' | translate }}</p>
        <p class="date">{{ formatDate(campaign.finish) }}</p>
      </div>
    </div>
    <p class="delivery-count" *ngIf="!!hasCampaignCreation">
      {{ deliveryCountLabel }}
    </p>
  </div>
  <div class="compared campaign" *ngIf="comparedCampaign">
    <h4>{{ 'Comparison campaign' | translate }}</h4>
    <p class="name">{{ comparedCampaign.name }}</p>
    <div class="top">
      <img src="/assets/img/icons/color/map-xs.svg" />
      <p>{{ comparedCampaignPOIs.length }} POIs</p>
      <div class="spacer"></div>
      <button (click)="showAll()">{{ 'Show all' | translate }}</button>
    </div>
    <div class="dates">
      <div class="date-row">
        <p class="label">{{ 'Start' | translate }}</p>
        <p class="date">{{ formatDate(comparedCampaign.start) }}</p>
      </div>
      <div class="date-row">
        <p class="label">{{ 'End' | translate }}</p>
        <p class="date">{{ formatDate(comparedCampaign.finish) }}</p>
      </div>
    </div>
    <p class="delivery-count" *ngIf="!!hasCampaignCreation">
      {{ 'The campaign lasts' | translate }}
      {{ getNumDeliveries(comparedCampaign) }}
      {{ 'deliveries' | translate }}
      ({{ getNumDays(comparedCampaign) }} {{ 'days' | translate }})
    </p>
  </div>
  <div *ngIf="comparedCampaign && hasCampaignCreation">
    <latitude-toggle
      [label]="'Show only common POIs' | translate"
      [checked]="showOnlyCommonPOIs"
      (change)="toggleCommonPOIsView()"
    >
    </latitude-toggle>
  </div>
</app-widget-base>
